import React, { useState, useEffect, useMemo } from 'react';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc.js';
import timezone from 'dayjs/plugin/timezone.js';
import isBetween from 'dayjs/plugin/isBetween.js'; // Pour les comparaisons d'intervalles
import localizedFormat from 'dayjs/plugin/localizedFormat.js'; // Pour les formats localisés comme PPPP
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter.js'; // Import plugin for comparison
import 'dayjs/locale/fr.js'; // Importer la locale française


import imageMiroirs from "./images/PXL_20250228_090416415.jpg"; // Exemple
import imageSalonDroit from "./images/PXL_20250228_090513408.jpg"; // Exemple
import imageSalon from "./images/PXL_20250301_084158399.jpg"; // Exemple
import imageBureau from "./images/PXL_20250228_090522839.jpg"; // Une image de secours locale
import logoMCoiffure from './images/logoMCoiffure.png';
import brushingIcon from './images/brushing.png';
import coiffageHIcon from './images/coiffageH.png';
import shampFIcon from './images/shampF.png';
import shampHIcon from './images/shampH.png';

// Appliquer les plugins à dayjs
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween);
dayjs.extend(localizedFormat);
dayjs.extend(isSameOrAfter); // Extend with comparison plugin
dayjs.locale('fr'); // Définir la locale globalement


// --- Data ---
const servicesData = {
  homme: {
    court: [
      // Base services (no flag)
      //{ name: 'Shampoing', price: 7, duration: 10, type: 'technique', subType: 'Préparation/Soin' },
      { name: 'Coiffage', price: 10, duration: 30, type: 'coupe', busyDuration: 30, includesStyling: true, includesShampoo: true }, // Standalone styling
      { name: 'Soin', price: 7, duration: 0, type: 'technique', subType: 'Préparation/Soin' },
      // Inclusive services (flag = true)
      { name: 'Coupe (ciseaux)', price: 21, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true, includesStyling: true },
      { name: 'Coupe tondeuse', price: 15, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true, includesStyling: true },
      { name: 'Mèches alu court', price: 35, applicationDuration: 60, pauseDuration: 60, finishDuration: 30, duration: 150, busyDuration: 90, type: 'technique', subType: 'Mèches', includesShampoo: true, includesStyling: true },
      { name: 'Balayage court', price: 30, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60, type: 'technique', subType: 'Balayage', includesShampoo: true, includesStyling: true },
      { name: 'Coloration d\'oxydation', price: 33, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60, type: 'technique', subType: 'Coloration', includesShampoo: true, includesStyling: true },
      { name: 'Coloration ton sur ton', price: 33, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60, type: 'technique', subType: 'Coloration', includesShampoo: true, includesStyling: true },
      { name: 'Coloration sans ammoniaque', price: 38, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60, type: 'technique', subType: 'Coloration', includesShampoo: true, includesStyling: true },
      { name: 'Permanente court', price: 40, aapplicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60, type: 'technique', subType: 'Forme', includesShampoo: true, includesStyling: true },
      { name: 'Défrisage court', price: 45, applicationDuration: 30, pauseDuration: 30, finishDuration: 60, duration: 120, busyDuration: 90, type: 'technique', subType: 'Forme', includesShampoo: true, includesStyling: true },
      // Minor services (no flag)
      { name: 'Barbe', price: 5, duration: 15, type: 'coupe' },
    ],
    'mi-long': [
      //{ name: 'Shampoing', price: 7, duration: 10, type: 'technique', subType: 'Préparation/Soin' },
      { name: 'Coiffage', price: 10, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true, includesStyling: true },
      { name: 'Soin', price: 7, duration: 0, type: 'technique', subType: 'Préparation/Soin' },

      { name: 'Coupe (ciseaux)', price: 21, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true, includesStyling: true },
      { name: 'Coupe tondeuse', price: 15, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true, includesStyling: true },
      { name: 'Mèches alu mi-long', price: 40, applicationDuration: 90, pauseDuration: 60, finishDuration: 30, duration: 180, busyDuration: 120, type: 'technique', subType: 'Mèches', includesShampoo: true, includesStyling: true },
      { name: 'Balayage mi-long', price: 35, applicationDuration: 60, pauseDuration: 60, finishDuration: 30, duration: 150, busyDuration: 90, type: 'technique', subType: 'Balayage', includesShampoo: true, includesStyling: true },
      { name: 'Coloration d\'oxydation', price: 33, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60, type: 'technique', subType: 'Coloration', includesShampoo: true, includesStyling: true },
      { name: 'Coloration ton sur ton', price: 33, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60, type: 'technique', subType: 'Coloration', includesShampoo: true, includesStyling: true },
      { name: 'Coloration sans ammoniaque', price: 38, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60, type: 'technique', subType: 'Coloration', includesShampoo: true, includesStyling: true },
      { name: 'Permanente mi-long', price: 50, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60, type: 'technique', subType: 'Forme', includesShampoo: true, includesStyling: true },
      { name: 'Défrisage mi-long', price: 55, applicationDuration: 60, pauseDuration: 30, finishDuration: 60, duration: 150, busyDuration: 120, type: 'technique', subType: 'Forme', includesShampoo: true, includesStyling: true },
      { name: 'Barbe', price: 5, duration: 15, type: 'coupe' },
    ],
    long: [
      //{ name: 'Shampoing', price: 7, duration: 15, type: 'technique', subType: 'Préparation/Soin' },
      { name: 'Coiffage', price: 10, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true, includesStyling: true  },
      { name: 'Soin', price: 7, duration: 0, type: 'technique', subType: 'Préparation/Soin' },
      { name: 'Coupe (ciseaux)', price: 21, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true, includesStyling: true },
      { name: 'Coupe tondeuse', price: 15, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true, includesStyling: true },
      { name: 'Mèches alu long', price: 50, applicationDuration: 90, pauseDuration: 60, finishDuration: 30, duration: 180, busyDuration: 120, type: 'technique', subType: 'Mèches', includesShampoo: true, includesStyling: true },
      { name: 'Balayage long', price: 40, applicationDuration: 60, pauseDuration: 60, finishDuration: 30, duration: 150, busyDuration: 90, type: 'technique', subType: 'Balayage', includesShampoo: true, includesStyling: true },
      { name: 'Coloration d\'oxydation', price: 33, applicationDuration: 30, pauseDuration: 30, finishDuration: 45, duration: 105, busyDuration: 75, type: 'technique', subType: 'Coloration', includesShampoo: true, includesStyling: true },
      { name: 'Coloration ton sur ton', price: 33, applicationDuration: 30, pauseDuration: 30, finishDuration: 45, duration: 105, busyDuration: 75, type: 'technique', subType: 'Coloration', includesShampoo: true, includesStyling: true },
      { name: 'Coloration sans ammoniaque', price: 38, applicationDuration: 30, pauseDuration: 30, finishDuration: 45, duration: 105, busyDuration: 75, type: 'technique', subType: 'Coloration', includesShampoo: true, includesStyling: true },
      { name: 'Permanente long', price: 55, applicationDuration: 60, pauseDuration: 30, finishDuration: 30, duration: 120, busyDuration: 90, type: 'technique', subType: 'Forme', includesShampoo: true, includesStyling: true },
      { name: 'Barbe', price: 5, duration: 15, type: 'coupe' },
    ]
  },
  femme: {
    court: [
      // Base services
      //{ name: 'Shampoing', price: 7, duration: 0, busyDuration:0, type: 'technique', subType: 'Préparation/Soin' },
      // Inclusive services
      { name: 'Coupe entretien', price: 33, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true, includesStyling: true },
      { name: 'Coupe transformation', price: 34, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true, includesStyling: true },
      { name: 'Coupe nuque', price: 26, duration: 15, busyDuration: 15, type: 'coupe', includesShampoo: true, includesStyling: true},
      { name: 'Frange', price: 6, duration: 10, busyDuration: 10,type: 'coupe' },
      { name: 'Soin', price: 8, duration: 0, busyDuration: 0, type: 'technique', subType: 'Préparation/Soin' },
      { name: 'Brushing court', price: 20, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true}, // Standalone styling

      { name: 'Coloration d\'oxydation', price: 43, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60, type: 'technique', subType: 'Coloration', includesShampoo: true, includesStyling: true },
      { name: 'Coloration ton sur ton', price: 43, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60, type: 'technique', subType: 'Coloration', includesShampoo: true, includesStyling: true },
      { name: 'Coloration sans ammoniaque', price: 48, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60, type: 'technique', subType: 'Coloration', includesShampoo: true, includesStyling: true },
      { name: 'Mèches alu court', price: 65, applicationDuration: 60, pauseDuration: 60, finishDuration: 30, duration: 150, busyDuration: 90, type: 'technique', subType: 'Mèches', includesShampoo: true, includesStyling: true },
      { name: 'Balayage court', price: 60, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60, type: 'technique', subType: 'Balayage', includesShampoo: true, includesStyling: true },
      { name: 'Permanente court', price: 60, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60, type: 'technique', subType: 'Forme', includesShampoo: true, includesStyling: true },
      { name: 'Défrisage court', price: 90, applicationDuration: 30, pauseDuration: 30, finishDuration: 60, duration: 120, busyDuration: 90, type: 'technique', subType: 'Forme', includesShampoo: true, includesStyling: true },
      { name: 'Lissage court', price: 110, applicationDuration: 30, pauseDuration: 30, finishDuration: 60, duration: 120, busyDuration: 90, type: 'technique', subType: 'Forme', includesShampoo: true, includesStyling: true },
      // Minor/Event services (no flag)
      { name: 'Chignon simple', price: 45, duration: 45, busyDuration: 45, type: 'evenementiel' },
      { name: 'Chignon soirée', price: 50, duration: 60, busyDuration: 60, type: 'evenementiel' },
      { name: 'Chignon mariée, 2 RDV inclus dont celui-ci pour l\'essai avant mariage', price: 120, duration: 120, busyDuration: 120, type: 'evenementiel' },
    ],
    'mi-long': [
      // Base services
      //{ name: 'Shampoing', price: 7, duration: 0, busyDuration:0, type: 'technique', subType: 'Préparation/Soin', isBase: true },
      // Inclusive services
      { name: 'Coupe entretien', price: 37, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true, includesStyling: true },
      { name: 'Coupe transformation', price: 38, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true, includesStyling: true },
      { name: 'Frange', price: 6, duration: 10, busyDuration: 10,type: 'coupe' },
      { name: 'Soin', price: 8, duration: 0, busyDuration: 0, type: 'technique', subType: 'Préparation/Soin' },
      { name: 'Brushing mi-long', price: 24, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true, isBase: true}, // Standalone styling

      { name: 'Coloration d\'oxydation', price: 47, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60, type: 'technique', subType: 'Coloration', includesShampoo: true, includesStyling: true },
      { name: 'Coloration ton sur ton', price: 47, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60, type: 'technique', subType: 'Coloration', includesShampoo: true, includesStyling: true },
      { name: 'Coloration sans ammoniaque', price: 52, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60, type: 'technique', subType: 'Coloration', includesShampoo: true, includesStyling: true },
      { name: 'Mèches alu mi-long', price: 79, applicationDuration: 90, pauseDuration: 60, finishDuration: 30, duration: 180, busyDuration: 120, type: 'technique', subType: 'Mèches', includesShampoo: true, includesStyling: true },
      { name: 'Balayage mi-long', price: 74, applicationDuration: 60, pauseDuration: 60, finishDuration: 30, duration: 150, busyDuration: 90, type: 'technique', subType: 'Balayage', includesShampoo: true, includesStyling: true },
      { name: 'Permanente mi-long', price: 74, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60, type: 'technique', subType: 'Forme', includesShampoo: true, includesStyling: true },
      { name: 'Défrisage mi-long', price: 104, applicationDuration: 60, pauseDuration: 30, finishDuration: 60, duration: 150, busyDuration: 120, type: 'technique', subType: 'Forme', includesShampoo: true, includesStyling: true },
      { name: 'Lissage mi-long', price: 124, applicationDuration: 60, pauseDuration: 30, finishDuration: 60, duration: 150, busyDuration: 120, type: 'technique', subType: 'Forme', includesShampoo: true, includesStyling: true },
      // Minor/Event services (no flag)
      { name: 'Chignon simple', price: 45, duration: 45, busyDuration: 45, type: 'evenementiel' },
      { name: 'Chignon soirée', price: 50, duration: 60, busyDuration: 60, type: 'evenementiel' },
      { name: 'Chignon mariée, 2 RDV inclus dont celui-ci pour l\'essai avant mariage', price: 120, duration: 120, busyDuration: 120, type: 'evenementiel' },
    ],
    long: [
      // Base services
      //{ name: 'Shampoing', price: 7, duration: 0, busyDuration:0, type: 'technique', subType: 'Préparation/Soin' },
      // Inclusive services
      { name: 'Coupe entretien', price: 42, duration: 45, busyDuration: 45, type: 'coupe', includesShampoo: true, includesStyling: true },
      { name: 'Coupe transformation', price: 43, duration: 45, busyDuration: 45, type: 'coupe', includesShampoo: true, includesStyling: true },
      { name: 'Frange', price: 6, duration: 10, busyDuration: 10,type: 'coupe' },
      { name: 'Soin', price: 8, duration: 0, busyDuration: 0, type: 'technique', subType: 'Préparation/Soin' },
      { name: 'Brushing long', price: 29, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true}, // Standalone styling

      { name: 'Coloration d\'oxydation', price: 52, applicationDuration: 30, pauseDuration: 30, finishDuration: 45, duration: 105, busyDuration: 75, type: 'technique', subType: 'Coloration', includesShampoo: true, includesStyling: true },
      { name: 'Coloration ton sur ton', price: 52, applicationDuration: 30, pauseDuration: 30, finishDuration: 45, duration: 105, busyDuration: 75, type: 'technique', subType: 'Coloration', includesShampoo: true, includesStyling: true },
      { name: 'Coloration sans ammoniaque', price: 57, applicationDuration: 30, pauseDuration: 30, finishDuration: 45, duration: 105, busyDuration: 75, type: 'technique', subType: 'Coloration', includesShampoo: true, includesStyling: true },
      { name: 'Mèches alu long', price: 94, applicationDuration: 90, pauseDuration: 60, finishDuration: 30, duration: 180, busyDuration: 120, type: 'technique', subType: 'Mèches', includesShampoo: true, includesStyling: true },
      { name: 'Balayage long', price: 89, applicationDuration: 60, pauseDuration: 60, finishDuration: 30, duration: 150, busyDuration: 90, type: 'technique', subType: 'Balayage', includesShampoo: true, includesStyling: true },
      { name: 'Permanente long', price: 89, applicationDuration: 60, pauseDuration: 30, finishDuration: 30, duration: 120, busyDuration: 90, type: 'technique', subType: 'Forme', includesShampoo: true, includesStyling: true },
      { name: 'Défrisage long', price: 119, applicationDuration: 60, pauseDuration: 30, finishDuration: 60, duration: 150, busyDuration: 120, type: 'technique', subType: 'Forme', includesShampoo: true, includesStyling: true },
      { name: 'Lissage long', price: 139, applicationDuration: 60, pauseDuration: 30, finishDuration: 60, duration: 150, busyDuration: 120, type: 'technique', subType: 'Forme', includesShampoo: true, includesStyling: true },
      // Minor/Event services (no flag)
      { name: 'Chignon simple', price: 45, duration: 45, busyDuration: 45, type: 'evenementiel' },
      { name: 'Chignon soirée', price: 50, duration: 60, busyDuration: 60, type: 'evenementiel' },
      { name: 'Chignon mariée, 2 RDV inclus dont celui-ci pour l\'essai avant mariage', price: 120, duration: 120, busyDuration: 120, type: 'evenementiel' },
    ]
  },
  enfant: {
      court: [
        { name: 'Coupe bébé', price: 10, duration: 30, busyDuration: 30, type: 'coupe'},
        { name: 'Coupe fille (-12 ans) séchage naturel', price: 22, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true, includesStyling: true},
        { name: 'Coupe garçon (-12 ans)', price: 17, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true, includesStyling: true},
        { name: 'Coupe ado fille séchage naturel', price: 27, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true, includesStyling: true},
        { name: 'Coupe ado garçon', price: 18, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true, includesStyling: true },
        { name: 'Frange', price: 6, duration: 0, type: 'coupe' },
        { name: 'Soin', price: 8, duration: 0, type: 'technique', subType: 'Préparation/Soin' },

        { name: 'Brushing court', price: 8, duration: 15, busyDuration: 15, type: 'coupe' },

        { name: 'Tresse court', price: 5, duration: 0, busyDuration: 10, type: 'coupe' },
        { name: 'Chignon', price: 20, duration: 30, busyDuration: 30, type: 'coupe' },

        { name: 'Coloration (+16 ans)', price: 23, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60, type: 'technique', subType: 'Coloration' },
        { name: 'Coloration ton sur ton (+16 ans)', price: 23, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60, type: 'technique', subType: 'Coloration' },
        { name: 'Mèches (accord parental)', price: 40, applicationDuration: 60, pauseDuration: 60, finishDuration: 30, duration: 150, busyDuration: 90, type: 'technique', subType: 'Mèches' },
        { name: 'Permanente', price: 40, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60, type: 'technique', subType: 'Forme' },
      ],
       'mi-long': [
        { name: 'Coupe bébé', price: 10, duration: 30, busyDuration: 30, type: 'coupe'},
        { name: 'Coupe fille (-12 ans) séchage naturel', price: 22, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true, includesStyling: true},
        { name: 'Coupe garçon (-12 ans)', price: 17, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true, includesStyling: true},
        { name: 'Coupe ado fille séchage naturel', price: 27, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true, includesStyling: true},
        { name: 'Coupe ado garçon', price: 18, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true, includesStyling: true },
        { name: 'Frange', price: 6, duration: 0, type: 'coupe' },
        { name: 'Soin', price: 8, duration: 0, type: 'technique', subType: 'Préparation/Soin' },

        { name: 'Brushing mi-long', price: 12, duration: 15, busyDuration: 15, type: 'coupe' },

        { name: 'Tresse mi-long', price: 5, duration: 0, busyDuration: 10, type: 'coupe' },
        { name: 'Chignon', price: 20, duration: 30, busyDuration: 30, type: 'coupe' },

        { name: 'Coloration (+16 ans)', price: 23, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60, type: 'technique', subType: 'Coloration' },
        { name: 'Coloration ton sur ton (+16 ans)', price: 23, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60, type: 'technique', subType: 'Coloration' },
        { name: 'Mèches (accord parental)', price: 40, applicationDuration: 60, pauseDuration: 60, finishDuration: 30, duration: 150, busyDuration: 90, type: 'technique', subType: 'Mèches' },
        { name: 'Permanente', price: 40, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60, type: 'technique', subType: 'Forme' },
       ],
       long: [
        { name: 'Coupe bébé', price: 10, duration: 30, busyDuration: 30, type: 'coupe'},
        { name: 'Coupe fille (-12 ans) séchage naturel', price: 22, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true, includesStyling: true},
        { name: 'Coupe garçon (-12 ans)', price: 17, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true, includesStyling: true},
        { name: 'Coupe ado fille séchage naturel', price: 27, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true, includesStyling: true},
        { name: 'Coupe ado garçon', price: 18, duration: 30, busyDuration: 30, type: 'coupe', includesShampoo: true, includesStyling: true },
        { name: 'Frange', price: 6, duration: 0, type: 'coupe' },
        { name: 'Soin', price: 8, duration: 0, type: 'technique', subType: 'Préparation/Soin' },

        { name: 'Brushing long', price: 17, duration: 15, busyDuration: 15, type: 'coupe' },

        { name: 'Tresse long', price: 15, duration: 0, busyDuration: 10, type: 'coupe' },
        { name: 'Chignon', price: 20, duration: 30, busyDuration: 30, type: 'coupe' },

        { name: 'Coloration (+16 ans)', price: 23, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60,  type: 'technique', subType: 'Coloration' },
        { name: 'Coloration ton sur ton (+16 ans)', price: 23, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60,  type: 'technique', subType: 'Coloration' },
        { name: 'Mèches (accord parental)', price: 40, applicationDuration: 60, pauseDuration: 60, finishDuration: 30, duration: 150, busyDuration: 90, type: 'technique', subType: 'Mèches' },
        { name: 'Permanente', price: 40, applicationDuration: 30, pauseDuration: 30, finishDuration: 30, duration: 90, busyDuration: 60, type: 'technique', subType: 'Forme' },
       ]
  }
};


// --- Helper Functions ---

const getTodayDateString = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const day = today.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const calculateEndTime = (startTime, durationMinutes) => {
  if (!startTime || !durationMinutes || durationMinutes <= 0) return null;
  try {
    const [startHour, startMinute] = startTime.split(':').map(Number);
    if (isNaN(startHour) || isNaN(startMinute)) return null;
    const date = new Date();
    date.setHours(startHour, startMinute, 0, 0);
    date.setMinutes(date.getMinutes() + durationMinutes);
    const endHour = date.getHours().toString().padStart(2, '0');
    const endMinute = date.getMinutes().toString().padStart(2, '0');
    return `${endHour}:${endMinute}`;
  } catch (error) {
    console.error("Error calculating end time:", error);
    return null;
  }
};

const renderStars = (rating) => {
    const roundedRating = Math.round(rating * 2) / 2;
    const fullStars = Math.floor(roundedRating);
    const halfStar = roundedRating % 1 !== 0;
    const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

    return (
        <div className="flex items-center text-yellow-400">
            {Array(fullStars).fill(0).map((_, i) => <span key={`full-${i}`}>★</span>)}
            {halfStar && <span key="half">★</span>}
            {Array(emptyStars).fill(0).map((_, i) => <span key={`empty-${i}`} className="text-gray-300">☆</span>)}
        </div>
    );
};

// Define Backend URL (Make sure your backend server is running)
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api'; // Use environment variable or default

// Helper to calculate adjusted totals
const calculateAdjustedTotals = (appointments) => {
    let finalTotalDuration = 0;
    let finalTotalPrice = 0;
    let overallAdjustmentApplied = false;

    appointments.forEach((app, index) => {
        console.log(`Appointment Slot ${index + 1} (${app.clientType} / ${app.hairLength}):`);
        const clientType = app.clientType;
        const hairLength = app.hairLength;
        //const gender = app.gender;
        let slotRawDuration = 0;
        let slotRawPrice = 0;
        //let shampooIncludedCount = 0;
        let stylingIncludedCount = 0;
        let slotAdjustmentDuration = 0;
        let slotAdjustmentPrice = 0;

        const allSelectedServices = [
            ...(app.coupeServices || []),
            ...(app.techniqueServices || []),
            ...(app.evenementielServices || [])
        ];

        allSelectedServices.forEach(service => {
            slotRawDuration += service.duration || 0;
            slotRawPrice += service.price || 0;
            //if (service.includesShampoo) { shampooIncludedCount++; }
            if (service.includesStyling) { stylingIncludedCount++; }
        });

        // Find base services dynamically for the current slot
        const allServicesForSlot = servicesData[clientType]?.[hairLength] || [];
        let baseStyling = null;

        if (clientType === 'femme') {
            baseStyling = allServicesForSlot.find(s => s.name.startsWith('Brushing') && s.type === 'coupe');
        } else if (clientType === 'homme') {
            baseStyling = allServicesForSlot.find(s => s.name === 'Coiffage' && s.type === 'coupe');
        } else if (clientType === 'enfant') {
            baseStyling = allServicesForSlot.find(s => s.name.toLowerCase().includes('séchage naturel'));

        }

        // Apply adjustments based on counts and found base services H/F
        if (stylingIncludedCount >= 2 && baseStyling) {
             slotAdjustmentDuration += (baseStyling.duration || 0);
             slotAdjustmentPrice += (baseStyling.price || 0);
             overallAdjustmentApplied = true;
        }

        // --- Ajustement spécifique enfant (séchage naturel + coloration) ---
        else if (clientType === 'enfant' && baseStyling) {
            const hasColoration = allSelectedServices.some(s => s.subType === 'Coloration');
            if (hasColoration) {
                slotAdjustmentDuration += (baseStyling.duration || 0);
                // prix non modifié (on laisse payer coupe + coloration)
                overallAdjustmentApplied = true;
            }
        }

        finalTotalDuration += (slotRawDuration - slotAdjustmentDuration);
        finalTotalPrice += (slotRawPrice - slotAdjustmentPrice);
    });

    return {
        totalDuration: finalTotalDuration > 0 ? finalTotalDuration : 0,
        totalPrice: finalTotalPrice > 0 ? finalTotalPrice : 0,
        adjustmentApplied: overallAdjustmentApplied
    };
};

// --- Components ---

function Header() {
  return (
    <header className="w-full bg-black text-white p-4 text-center shadow-md flex-shrink-0 z-20">
      {/* Flex container to align logo and title */}
      <div className="flex justify-center items-center">
        <img
            src={logoMCoiffure}
            alt="Logo Marion Coiffure"
            className="h-10 w-auto mr-3" // Adjust height (h-10 = 2.5rem) and right margin as needed
            onError={(e) => { e.target.style.display='none'; }} // Hide if logo fails to load
        />
        <h1 className="text-5xl font-[cursive] tracking-wider">Marion Coiffure</h1>
      </div>
      <p className="text-sm text-gray-300 mt-2">L'élégance au bout des ciseaux</p>
    </header>
  );
}

function Footer() {
  const address = "130 Rue de la Gare, 80160 Conty";
  const phone = "06 51 63 82 91";
  const phoneLink = "tel:0651638291"; // Format for tel link (no spaces)
  // Encode address for URL
  const mapLink = `https://maps.app.goo.gl/4HMDJyqNYzBWg9kQ7`;
  return (
    <footer className="w-full bg-black text-white p-4 text-center text-xs flex-shrink-0 z-20">
        © {new Date().getFullYear()} Marion Coiffure. Tous droits réservés.
        <p className="mt-1 text-gray-400">
            {/* Clickable Address Link */}
            <a href={mapLink} target="_blank" rel="noopener noreferrer" className="hover:underline" title="Voir sur Google Maps">
                {address}
            </a>
            {/* Added non-breaking spaces around the separator */}
            &nbsp;|&nbsp;
            <a href={phoneLink} className="hover:underline" title="Appeler le salon">
                {phone}
            </a>
        </p>
    </footer>
    );
}

function Button({ onClick, children, variant = 'primary', className = '', disabled = false, type = 'button' }) {
  const baseStyle = 'px-6 py-3 rounded-md text-lg font-semibold transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2';
  const primaryStyle = 'bg-white text-black border border-black hover:bg-gray-200 focus:ring-black';
  const secondaryStyle = 'bg-black text-white border border-white hover:bg-gray-800 focus:ring-white';
  const disabledStyle = 'bg-gray-300 text-gray-500 cursor-not-allowed border-gray-300';
  const style = disabled ? disabledStyle : (variant === 'primary' ? primaryStyle : secondaryStyle);
  return ( <button type={type} onClick={onClick} className={`${baseStyle} ${style} ${className}`} disabled={disabled}> {children} </button> );
}



function Step1Action({ setStep, setShowAnimation }) {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState(null);
  const [isReviewsWidgetOpen, setIsReviewsWidgetOpen] = useState(false);

  const handleImageError = (e) => {
    e.target.onerror = null; // Prevent infinite loop if placeholder also fails
    e.target.src = imageSalonDroit; // Use local placeholder on error
    console.warn(`Failed to load image: ${e.target.alt}`);
  };
  const openLightbox = (imageSrc) => {
    setLightboxImage(imageSrc);
    setLightboxOpen(true);
  };
  const closeLightbox = () => {
      setLightboxOpen(false);
      setLightboxImage(null);
  };
  // Define images with explicit landscape/portrait hint if needed for ordering
  const landscapeImage = { src: imageSalon, alt: "Ambiance du salon de coiffure" };
  const portraitImages = [
    { src: imageMiroirs, alt: "Exemple de coupe de cheveux moderne" },
    { src: imageBureau, alt: "Exemple de coloration ou mèches" },
  ];
  const openingHours = [
      { day: "Lundi", hours: "RDV à domicile (sur appel)" },
      { day: "Mardi", hours: "09:00 - 19:00" },
      { day: "Mercredi", hours: "Fermé" },
      { day: "Jeudi", hours: "09:00 - 19:00" },
      { day: "Vendredi", hours: "09:00 - 19:00" },
      { day: "Samedi", hours: "09:00 - 16:00" },
      { day: "Dimanche", hours: "Fermé" },
  ];
    // Get current day (1 for Monday, ..., 7 for Sunday)
  const todayIndex = dayjs().day(); // dayjs().day() gives 0 (Sun) to 6 (Sat)
  // Adjust so Monday is 1, Sunday is 7
  const currentDayOfWeek = todayIndex === 0 ? 7 : todayIndex;
  const goToStep2 = () => {
    setStep(2);
    setShowAnimation(false); // Masquer l'animation
  };
  return (
    <div className="space-y-6 flex flex-col items-center">
      <div className="relative z-10 flex flex-col items-center justify-center text-center p-5 bg-black bg-opacity-10 backdrop-blur-sm rounded-xl shadow-lg max-w-md mx-auto">
        <h2 className="text-3xl font-[cursive] mb-2 text-gray-300">Bienvenue dans mon salon de coiffure</h2>
        <Button onClick={goToStep2} className="w-64 bg-opacity-80">Prendre RDV</Button>
    </div>
      <GoogleReviewsWidget isSummary={true} openFullWidget={() => setIsReviewsWidgetOpen(true)} />



{/* --- Responsive Image Grid Layout --- */}
<div className="grid grid-cols-2 md:grid-cols-3 gap-4 w-full mt-8">

{/* Landscape Image */}
<div
  // Changed from <a> to <div> with onClick
  onClick={() => openLightbox(landscapeImage.src)}
  className="z-10 col-span-2 md:col-span-1 block shadow-lg rounded-lg overflow-hidden transition-transform duration-200 hover:scale-105 cursor-pointer"
>
  <img
    src={landscapeImage.src}
    alt={landscapeImage.alt}
    className="w-full h-48 object-cover"
    onError={handleImageError}
  />
</div>

{/* Portrait Images */}
{portraitImages.map((image, index) => (
  <div
    key={index}
    // Changed from <a> to <div> with onClick
    onClick={() => openLightbox(image.src)}
    className="z-10 block shadow-lg rounded-lg overflow-hidden transition-transform duration-200 hover:scale-105 cursor-pointer"
  >
    <img
      src={image.src}
      alt={image.alt}
      className="w-full h-48 object-cover"
      onError={handleImageError}
    />
  </div>
))}
</div>
{/* --- End Image Layout --- */}

{/* --- ADDED: Lightbox Modal --- */}
{lightboxOpen && lightboxImage && (
    <div
        // Overlay background
        className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
        onClick={closeLightbox} // Close on overlay click
    >
        {/* Lightbox container (prevents closing when clicking image) */}
        <div
            className="relative bg-white p-2 rounded-lg shadow-xl max-w-3xl max-h-[80vh]"
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the box
        >
            {/* Close Button */}
            <button
                onClick={closeLightbox}
                className="absolute -top-2 -right-2 bg-black text-white rounded-full h-8 w-8 flex items-center justify-center text-xl font-bold z-10 hover:bg-gray-700"
                aria-label="Fermer"
            >
                &times; {/* HTML entity for 'X' */}
            </button>
            {/* Enlarged Image */}
            <img
                src={lightboxImage}
                alt="Contenu agrandi"
                className="block max-w-full max-h-[calc(80vh-2rem)] object-contain rounded" // Limit size and maintain aspect ratio
                onError={handleImageError} // Use same error handler
            />
        </div>
        
    </div>
)}
{/* --- End Lightbox Modal --- */}
      <div className="w-full max-w-md mx-auto mt-12 lg:mt-16 bg-white p-3 rounded-xl shadow-lg border bg-opacity-20 border-gray-100">
          <h3 className="text-l font-semibold text-center mb-3">Horaires d'ouverture</h3>
          <ul className="space-y-2 text-sm">
              {openingHours.map((item, index) => {
                  const isToday = (index + 1) === currentDayOfWeek;
                  return (
                      <li key={item.day} className={`flex justify-between items-center p-2 rounded-md ${isToday ? 'bg-gray-100 font-bold bg-opacity-10'  : ''}`}>
                          <span>{item.day}</span>
                          <span className={item.hours === "Fermé" ? "text-red-500" : "text-gray-400"}>{item.hours}</span>
                      </li>
                  );
              })}
          </ul>
      </div>
      {isReviewsWidgetOpen && <GoogleReviewsWidget isSummary={false} closeWidget={() => setIsReviewsWidgetOpen(false)} />}

    </div>
  );
}

function GoogleReviewsWidget({ isSummary = false, openFullWidget, closeWidget }) {
    const [reviewsData, setReviewsData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchReviews = async () => {
            setIsLoading(true);
            setError('');
            try {
                const response = await fetch(`${API_URL}/reviews`);
                const data = await response.json();
                if (!response.ok) {
                    throw new Error(data.message || 'Erreur lors du chargement des avis.');
                }
                setReviewsData(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setIsLoading(false);
            }
        };
        fetchReviews();
    }, []);

    if (isSummary) {
        return (
            <div className="relative z-10 flex flex-col items-center justify-center text-center p-5 bg-black bg-opacity-10 backdrop-blur-sm rounded-xl shadow-lg max-w-md mx-auto">
                {isLoading && <p className="text-center text-gray-500">Chargement des avis...</p>}
                {error && <p className="text-center text-red-500">{error}</p>}
                {reviewsData && (
                    <div className="text-center">
                        <h3 className="text-xl font-semibold mb-2 text-gray-300">Les avis de nos clients</h3>
                        <div className="flex items-center justify-center space-x-2 mb-3">
                            <span className="text-2xl font-bold text-gray-300">{reviewsData.rating}</span>
                            {renderStars(reviewsData.rating)}
                            <span className="text-sm text-gray-300">({reviewsData.user_ratings_total} avis)</span>
                        </div>
                        <Button onClick={openFullWidget} variant="secondary" className="!text-sm !py-1 !px-3">
                            Lire les avis
                        </Button>
                    </div>
                )}
            </div>
        );
    }

    return (
        <div onClick={closeWidget} className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[80vh] flex flex-col">
                <div className="p-4 border-b flex justify-between items-center flex-shrink-0">
                    {isLoading ? <h3 className="text-lg font-semibold">Chargement des avis...</h3> : (
                        <div className="flex items-center">
                            <h3 className="text-lg font-semibold mr-3">{reviewsData?.name}</h3>
                             <div className="flex items-baseline">
                                <span className="text-yellow-500 font-bold mr-1">{reviewsData?.rating}</span>
                                {reviewsData?.rating && renderStars(reviewsData.rating)}
                                <span className="text-xs text-gray-500 ml-2">({reviewsData?.user_ratings_total} avis)</span>
                            </div>
                        </div>
                    )}
                    <button onClick={closeWidget} className="text-2xl text-gray-500 hover:text-gray-800">&times;</button>
                </div>
                <div className="p-4 overflow-y-auto">
                    {isLoading && <div className="text-center">Chargement...</div>}
                    {error && <div className="text-center text-red-500">{error}</div>}
                    {reviewsData?.reviews?.map((review, index) => (
                        <div key={index} className="border-b last:border-b-0 py-3">
                            <div className="flex items-center mb-2">
<div className="w-10 h-10 rounded-full mr-3 bg-gray-200 flex items-center justify-center flex-shrink-0">
    <span className="text-gray-500 font-semibold">{review.author_name.charAt(0).toUpperCase()}</span>
</div>                                <div>
                                    <p className="font-semibold">{review.author_name}</p>
                                    <div className="flex items-center text-xs">
                                        {renderStars(review.rating)}
                                        <span className="text-gray-500 ml-2">{review.relative_time_description}</span>
                                    </div>
                                </div>
                            </div>
                            <p className="text-sm text-gray-700">{review.text}</p>
                        </div>
                    ))}
                     {!isLoading && reviewsData && (
                         <div className="text-center mt-4">
                             <a href={reviewsData.url} target="_blank" rel="noopener noreferrer" className="text-sm text-blue-600 hover:underline">Voir tous les avis sur Google</a>
                         </div>
                     )}
                </div>
            </div>
        </div>
    );
}

// Step 2: Choose Client Type (Goes to Step 3 for everyone)
function Step2ClientType({ setStep, addAppointment, setShowAnimation  }) {
  const handleSelect = (type) => {
      addAppointment({ clientType: type });
      setStep(3);
  };
  const handleBack = () => {
    setStep(1); // Go back to Step 1
    setShowAnimation(true);
};
  return (
    <div className="z-10 space-y-6 flex flex-col items-center">
      <h2 className="text-3xl font-[cursive] mb-6 text-gray-300">Pour qui ?</h2>
      <Button onClick={() => handleSelect('homme')} className="w-64 bg-opacity-80">Homme</Button>
      <Button onClick={() => handleSelect('femme')} className="w-64 bg-opacity-80">Femme</Button>
      <Button onClick={() => handleSelect('enfant')} className="w-64 bg-opacity-80">Enfant</Button>
      <div className="w-full mt-8 flex justify-start">
           <Button onClick={handleBack} variant="secondary" className="text-sm !py-2 !px-4">
               Retour
           </Button>
      </div>
    </div>
    
  );
}

// Step 3: Choose Hair Length (Used for all client types)
function Step3HairLength({ setStep, updateCurrentAppointment, currentAppointment }) {
   useEffect(() => {
        if (!currentAppointment?.clientType) {
            console.log("Step3: Missing clientType, redirecting to step 2");
            setStep(2);
        }
    }, [currentAppointment, setStep]);

   if (!currentAppointment?.clientType) {
        return <p className="text-center text-red-500">Erreur : type de client non sélectionné. Redirection...</p>;
   }
   const handleSelect = (length) => {
       updateCurrentAppointment({ hairLength: length, coupeServices: [], techniqueServices: [] });
       setStep(4);
    };
  return (
    <div className="z-10 space-y-6 flex flex-col items-center">
      <h2 className="z-10 text-3xl font-[cursive] mb-6 p-2 bg-opacity-50 text-gray-300 backdrop-blur-sm rounded-xl shadow-lg max-w-md mx-auto">Quelle longueur de cheveux ?</h2>
      <Button onClick={() => handleSelect('court')} className="w-64 bg-opacity-80">Cheveux Courts</Button>
      <Button onClick={() => handleSelect('mi-long')} className="w-64 bg-opacity-80">Cheveux Mi-longs</Button>
      <Button onClick={() => handleSelect('long')} className="w-64 bg-opacity-80">Cheveux Longs</Button>
      <div className="w-full mt-8 flex justify-start">
           <Button onClick={() => setStep(2)} variant="secondary" className="text-sm !py-2 !px-4">
               Retour
           </Button>
      </div>
    </div>
  );
}

// Step 4: Select Services (Multi-select Buttons Vertical + Grouped Techniques)
function Step4SelectServices({ setStep, updateCurrentAppointment, currentAppointment }) {
  const [allCoupeServices, setAllCoupeServices] = useState([]);
  const [allTechniqueServices, setAllTechniqueServices] = useState([]);
  const [allEvenementielServices, setAllEvenementielServices] = useState([]);

  const [selectedCoupeNames, setSelectedCoupeNames] = useState(
      currentAppointment?.coupeServices?.map(s => s.name) || []
  );
  const [selectedTechniqueNames, setSelectedTechniqueNames] = useState(
      currentAppointment?.techniqueServices?.map(s => s.name) || []
  );
  const [selectedEvenementielNames, setSelectedEvenementielNames] = useState(
    currentAppointment?.evenementielServices?.map(s => s.name) || []
  );
  const [openSection, setOpenSection] = useState('none');
  const [selectionError, setSelectionError] = useState('');

  useEffect(() => {
    if (currentAppointment?.clientType && currentAppointment?.hairLength) {
      const allAvailable = servicesData[currentAppointment.clientType]?.[currentAppointment.hairLength] || [];
      
      setAllCoupeServices(allAvailable.filter(s => s.type === 'coupe'));
      setAllTechniqueServices(allAvailable.filter(s => s.type === 'technique'));
      setAllEvenementielServices(allAvailable.filter(s => s.type === 'evenementiel')); // Filter event services

      setSelectedCoupeNames(currentAppointment.coupeServices?.map(s => s.name) || []);
      setSelectedTechniqueNames(currentAppointment.techniqueServices?.map(s => s.name) || []);
      setSelectedEvenementielNames(currentAppointment.evenementielServices?.map(s => s.name) || []); // Update event state

    } else {
      console.log("Step4: Missing clientType or hairLength, redirecting...");
      setStep(3);
    }
  }, [currentAppointment, setStep]);

  const groupedTechniqueServices = useMemo(() => {
    return allTechniqueServices.reduce((groups, service) => {
      const key = service.subType || 'Autres';
      if (!groups[key]) { groups[key] = []; }
      groups[key].push(service);
      return groups;
    }, {});
  }, [allTechniqueServices]);

  const toggleSection = (section) => {
    setOpenSection(prev => (prev === section ? 'none' : section));
  };

  const handleToggleService = (service, type) => {
    if (type === 'coupe') {
      setSelectionError('');
      setSelectedCoupeNames(prevSelected =>
        prevSelected.includes(service.name)
          ? prevSelected.filter(name => name !== service.name)
          : [...prevSelected, service.name]
      );
    } else if (type === 'technique') {
      setSelectionError('');
      setSelectedTechniqueNames(prevSelected =>
        prevSelected.includes(service.name)
          ? prevSelected.filter(name => name !== service.name)
          : [...prevSelected, service.name]
      );
    } else if (type === 'evenementiel') {
      setSelectionError('');
       setSelectedEvenementielNames(prevSelected =>
        prevSelected.includes(service.name)
          ? prevSelected.filter(name => name !== service.name)
          : [...prevSelected, service.name]
      );
  }
};

const handleNext = () => {
  setSelectionError(''); // Clear previous error
  const finalSelectedCoupes = allCoupeServices.filter(s => selectedCoupeNames.includes(s.name));
  const finalSelectedTechniques = allTechniqueServices.filter(s => selectedTechniqueNames.includes(s.name));
  const finalSelectedEvenementiel = allEvenementielServices.filter(s => selectedEvenementielNames.includes(s.name));

  // Check if at least one service is selected
  if (finalSelectedCoupes.length === 0 && finalSelectedTechniques.length === 0 && finalSelectedEvenementiel.length === 0) {
      setSelectionError("Veuillez choisir au moins une prestation pour continuer."); // Set error message
      return; // Stop execution
  }

  // If services are selected, proceed
  updateCurrentAppointment({
      coupeServices: finalSelectedCoupes,
      techniqueServices: finalSelectedTechniques,
      evenementielServices: finalSelectedEvenementiel
  });
  setStep(5);
};

  if (!currentAppointment?.clientType || !currentAppointment?.hairLength) {
     return <p className="text-center text-red-500">Erreur : informations précédentes manquantes. Redirection...</p>;
  }

  // Reverted renderServiceButton to NOT show busyDuration
  const renderServiceButton = (service, type) => {
    const isSelected = (type === 'coupe' && selectedCoupeNames.includes(service.name)) ||
                       (type === 'technique' && selectedTechniqueNames.includes(service.name)) ||
                       (type === 'evenementiel' && selectedEvenementielNames.includes(service.name));

    // Determine which icons to use based on client type
    const isFemme = currentAppointment?.clientType === 'femme';
    const currentShampooIcon = isFemme ? shampFIcon : shampHIcon;
    const currentStylingIcon = isFemme ? brushingIcon : coiffageHIcon;

    return (
        <button
            key={`${type}-${service.name}`}
            onClick={() => handleToggleService(service, type)}
            className={`z-10 w-full text-left my-1 px-3 py-2 text-sm border rounded-md transition-colors duration-150 ${
                isSelected
                ? 'bg-white text-gray-800 border-gray-500 font-semibold bg-opacity-70'
                : 'bg-white text-black border-gray-300 hover:bg-gray-100 hover:border-gray-400 bg-opacity-100'
            }`}
        >
          {/* Service Name and Icons */}
          <div className="flex items-center justify-between">
              <span>{service.name}</span>
              {/* Icons shown if flags are true, using the correct icon */}
              <span className="flex-shrink-0">
                  {service.includesShampoo && (
                      <img
                          src={currentShampooIcon} // Use specific icon
                          alt="Shampoing inclus"
                          title="Shampoing inclus"
                          className="h-=5 w-5 inline-block ml-1"
                          onError={(e) => { e.target.style.display='none'; }}
                      />
                  )}
                  {service.includesStyling && (
                      <img
                          src={currentStylingIcon} // Use specific icon
                          alt="Coiffage/Brushing inclus"
                          title="Coiffage/Brushing inclus"
                          className="h-5 w-5 inline-block ml-1"
                          onError={(e) => { e.target.style.display='none'; }}
                      />
                  )}
              </span>
          </div>
          {/* Price and Duration */}
          <span className="text-xs block text-gray-600">
              ({service.price}€ - {service.duration} min)
          </span>
        </button>
    );
   };


  const getSelectedNamesText = (selectedNames) => {
      if (!selectedNames || selectedNames.length === 0) return 'Aucune';
      if (selectedNames.length === 1) return selectedNames[0];
      return `${selectedNames.length} sélection(s)`;
  };

  const showEvenementiel = currentAppointment?.clientType === 'femme' && allEvenementielServices.length > 0;

  const isFemme = currentAppointment?.clientType === 'femme';
  const legendShampooIcon = isFemme ? shampFIcon : shampHIcon;
  const legendStylingIcon = isFemme ? brushingIcon : coiffageHIcon;
  const legendStylingText = isFemme ? "Brushing inclus" : "Coiffage inclus";

  return (
    <div className="z-10 w-full max-w-lg mx-auto space-y-4 flex flex-col items-center ">
      <h2 className="z-10 text-3xl font-[cursive] mb-6 p-2 bg-opacity-50 text-gray-300 backdrop-blur-sm rounded-xl shadow-lg max-w-md mx-auto">Choisissez vos prestations</h2>
      
      {/* Dynamic Icon Legend */}
      <div className="text-xs text-black mb-6 p-2 flex flex-wrap justify-center items-center space-x-3 bg-opacity-70 bg-white rounded-xl ">
          {/* Shampoo Icon */}
          <span className="flex items-center">
              <img src={legendShampooIcon} alt="" className="h-4 w-4 mr-1"/> = Shampoing inclus
          </span>
          {/* Styling Icon */}
          <span className="flex items-center">
              <img src={legendStylingIcon} alt="" className="h-4 w-4 mr-1 "/> = {legendStylingText}
          </span>
      </div>

      {/* ADDED: Display Selection Error Message */}
      {selectionError && (
          <div className="z-10 w-full p-3 mb-4 text-center text-red-700 bg-red-100 border border-red-300 rounded-md">
              {selectionError}
          </div>
      )}
      {/* Coupe Section */}
      <div className="w-full ">
        <Button onClick={() => toggleSection('coupe')} variant="secondary" className="w-full !justify-between">
          <span>Coupe / Coiffage : <span className="font-normal italic text-gray-300">{getSelectedNamesText(selectedCoupeNames)}</span></span>
          <span className={`ml-2 transform transition-transform duration-200 ${openSection === 'coupe' ? 'rotate-180' : 'rotate-0'}`}>▼</span>
        </Button>
        {openSection === 'coupe' && (
          <div className="bg-opacity-20 mt-2 p-3 border border-gray-300 rounded-md bg-black flex flex-col">
            {allCoupeServices.length > 0 ? (
                allCoupeServices.map(service => renderServiceButton(service, 'coupe'))
            ) : (
                <p className="p-2 text-sm text-gray-500 italic text-center">Aucun service de coupe disponible.</p>
            )}
          </div>
        )}
      </div>
      <div className="w-full">
        <Button onClick={() => toggleSection('technique')} variant="secondary" className="w-full !justify-between">
          <span>Technique : <span className="font-normal italic text-gray-300">{getSelectedNamesText(selectedTechniqueNames)}</span></span>
           <span className={`ml-2 transform transition-transform duration-200 ${openSection === 'technique' ? 'rotate-180' : 'rotate-0'}`}>▼</span>
        </Button>
        {openSection === 'technique' && (
          <div className="bg-opacity-20 mt-2 p-3 border border-gray-300 rounded-md bg-black flex flex-col max-h-80 overflow-y-auto">
            {Object.keys(groupedTechniqueServices).length > 0 ? (
                Object.entries(groupedTechniqueServices).map(([subType, servicesInGroup]) => (
                    <div key={subType} className="mb-3">
                        <h4 className="text-sm font-semibold uppercase text-gray-300 border-b mb-2 pb-1">{subType}</h4>
                        {servicesInGroup.map(service => renderServiceButton(service, 'technique'))}
                    </div>
                ))
             ) : (
                <p className="p-2 text-sm text-gray-500 italic text-center">Aucun service technique disponible.</p>
            )}
          </div>
        )}
      </div>
      {/* Evenementiel Section (only for femme) */}
      {showEvenementiel && (
      <div className="w-full">
        <Button onClick={() => toggleSection('evenementiel')} variant="secondary" className="w-full !justify-between">
          <span>Coiffure Évènementielle : <span className="font-normal italic text-gray-300">{getSelectedNamesText(selectedEvenementielNames)}</span></span>
          <span className={`ml-2 transform transition-transform duration-200 ${openSection === 'evenementiel' ? 'rotate-180' : 'rotate-0'}`}>▼</span>
        </Button>
        {openSection === 'evenementiel' && (
          <div className="bg-opacity-20 mt-2 p-3 border border-gray-300 rounded-md bg-black flex flex-col max-h-80 overflow-y-auto">
            {allEvenementielServices.map(service => renderServiceButton(service, 'evenementiel'))}
          </div>
        )}
      </div>
      )}
       {/* Navigation Buttons */}
       <div className="z-10 flex justify-between items-center pt-4 w-full mt-4">
            <Button onClick={() => setStep(3)} variant="secondary" className="text-sm !py-2 !px-4">Retour</Button>
            <Button onClick={handleNext} className="w-auto bg-opacity-60"> Suivant </Button>
       </div>
    </div>
  );
}

// Step 5: Add Another Person? (Text changes applied)
function Step5AddPerson({ setStep, appointments }) {
  // Use the helper for calculation
  const { totalDuration, totalPrice, adjustmentApplied } = calculateAdjustedTotals(appointments);
  const totalServicesCount = appointments.reduce((total, app) => total + (app.coupeServices?.length || 0) + (app.techniqueServices?.length || 0) + (app.evenementielServices?.length || 0), 0);
  const handleAdd = () => { setStep(2); };
  const handleContinue = () => { setStep(6); };
  const handleBack = () => { setStep(4); };

  return (
      <div className="z-10 w-full max-w-md mx-auto space-y-6 flex flex-col items-center">
          <h2 className="z-10 text-3xl font-[cursive] mb-6 p-2 bg-opacity-50 text-gray-300 backdrop-blur-sm rounded-xl shadow-lg max-w-md mx-auto">Ajouter une autre prestation?</h2>
          <p className="text-center mb-1 z-10 p-2 bg-opacity-50 text-gray-300 backdrop-blur-sm rounded-xl shadow-lg">Vous avez {totalServicesCount} prestation(s) dans votre réservation.</p>
          {/* Display adjusted totals */}
          <p className="text-center text-sm mb-4 p-2 bg-opacity-50 text-gray-300 backdrop-blur-sm rounded-xl shadow-lg">
              Total estimé : <strong>{totalPrice}€</strong> ({totalDuration} min)
              {adjustmentApplied && <span className="text-xs block text-blue-600">(Ajustement pour shampoing/coiffage inclus appliqué)</span>}
          </p>
          <div className="w-full flex justify-center ">
              <Button onClick={handleAdd} variant="primary" className="w-full sm:w-auto bg-opacity-60">
                  Ajouter une prestation
              </Button>
          </div>
          <div className="z-10 flex justify-between items-center pt-6 w-full">
              <Button onClick={handleBack} variant="secondary" className="text-sm !py-2 !px-4">
                  Retour (Modifier Prestations)
              </Button>
              <Button onClick={handleContinue} variant="primary" className="w-full bg-opacity-60">
                  Continuer
              </Button>
          </div>
      </div>
  );
}

function Step6DateTime({ setStep, appointments, selectedDate, setSelectedDate, selectedTime, setSelectedTime }) {
  const { totalDuration, adjustmentApplied } = calculateAdjustedTotals(appointments);
  // Re-introduce state for API call
  const [availableSlots, setAvailableSlots] = useState([]);
  const [isLoadingSlots, setIsLoadingSlots] = useState(false);
  const [availabilityError, setAvailabilityError] = useState('');

  // Fetch availability when date or duration changes
  useEffect(() => {
      // Clear previous results and errors
      setAvailableSlots([]);
      setSelectedTime('');
      setAvailabilityError('');

      if (!selectedDate) {
          setAvailabilityError("Sélectionnez une date d'abord");
          return;
      }
      if (totalDuration <= 0) {
          setAvailabilityError("Sélectionnez des prestations d'abord (Étape 4)");
          return;
      }

      const fetchSlots = async () => {
          setIsLoadingSlots(true);
          const fetchUrl = `${API_URL}/availability?date=${selectedDate}&duration=${totalDuration}`;
          console.log("Step6DateTime - Fetching URL:", fetchUrl);

          try {
              const response = await fetch(fetchUrl);
              if (!response.ok) {
                   let errorMsg = `HTTP error ${response.status}`;
                   try {
                       const errorData = await response.json();
                       errorMsg = errorData.message || errorMsg;
                   } catch (parseError) {
                       errorMsg = `${response.status} ${response.statusText || 'Error'}`;
                       console.error("Non-JSON response received:", await response.text());
                   }
                  throw new Error(errorMsg);
              }
              const data = await response.json();
              console.log("Available slots received:", data.availableSlots);
              setAvailableSlots(data.availableSlots || []);
              if (!data.availableSlots || data.availableSlots.length === 0) {
                   setAvailabilityError("Aucun créneau disponible pour cette date et durée.");
              }
          } catch (error) {
              console.error("Failed to fetch available slots:", error);
              // Display specific error or a generic one
              setAvailabilityError(`Erreur: ${error.message || 'Impossible de récupérer les créneaux.'}`);
              setAvailableSlots([]);
          } finally {
              setIsLoadingSlots(false);
          }
      };
      fetchSlots();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate, totalDuration]); // Fetch when date or duration changes

  const today = getTodayDateString();
  const canProceed = selectedDate && selectedTime;
  const handleDateChange = (e) => { setSelectedDate(e.target.value); };
  const handleTimeChange = (e) => { setSelectedTime(e.target.value); };
  const handleNext = () => { if (canProceed) { setStep(7); } else { alert("Veuillez sélectionner une date et une heure."); } };

  // Determine the placeholder text for the time select dropdown
  const timeSelectPlaceholder = () => {
      if (isLoadingSlots) return 'Chargement des créneaux...';
      if (!selectedDate) return 'Sélectionnez une date d\'abord';
      if (totalDuration <= 0) return 'Sélectionnez des prestations d\'abord';
      if (availabilityError) return 'Erreur ou aucun créneau'; // Error message will be shown below
      if (availableSlots.length === 0) return 'Aucun créneau disponible';
      return '-- Sélectionnez une heure --';
  };

  return (
      <div className="z-10 w-full max-w-md mx-auto space-y-6 flex flex-col items-center ">
          <h2 className="z-10 text-3xl font-[cursive] mb-6 p-2 bg-opacity-50 text-gray-300 backdrop-blur-sm rounded-xl shadow-lg max-w-md mx-auto">Choisissez la date et l'heure</h2>
          <div className="w-full p-4 border border-gray-200 rounded-md bg-gray-50 text-center mb-4 bg-opacity-10">
              <p className="text-sm text-white">Durée totale estimée : <strong>{totalDuration} minutes</strong>.</p>
              {adjustmentApplied && <p className="text-xs text-blue-600 mt-1">(Ajustement pour shampoing/coiffage inclus appliqué)</p>}
               {/* Removed the potentially confusing text about final availability check */}
          </div>
          <div className="w-full">
              <label htmlFor="booking-date" className="block text-sm font-medium text-gray-300 mb-1">Date</label>
              <input type="date" id="booking-date" name="booking-date" value={selectedDate || ''} onChange={handleDateChange} min={today} required className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-black focus:border-black sm:text-sm" />
          </div>
          <div className="w-full">
               <label htmlFor="booking-time" className="block text-sm font-medium text-gray-300 mb-1">Heure</label>
               <select
                   id="booking-time"
                   name="booking-time"
                   value={selectedTime || ''}
                   onChange={handleTimeChange}
                   required
                   // Disable based on loading state, lack of date/duration, or if no slots were found (and no error occurred)
                   disabled={isLoadingSlots || !selectedDate || totalDuration <= 0 || (!availabilityError && availableSlots.length === 0)}
                   className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-black focus:border-black sm:text-sm bg-white disabled:bg-gray-100"
               >
                   <option value="" disabled>{timeSelectPlaceholder()}</option>
                   {/* Populate with available slots from API */}
                   {availableSlots.map(slot => ( <option key={slot} value={slot}>{slot}</option> ))}
               </select>
               {/* Display error message if fetching failed */}
               {availabilityError && !isLoadingSlots && (
                   <p className="text-sm text-red-500 mt-1 bg-white">{availabilityError}</p>
               )}
               <p className="bg-opacity-10 rounded-md text-xs text-gray-300 mt-1 bg-white">Heures d'ouverture : Mar/Jeu/Ven 9h-18h30, Sam 9h-16h - Appelez pour un RDV à domicile le lundi</p>
          </div>
          <div className="flex justify-between items-center pt-4 w-full">
               <Button onClick={() => setStep(5)} variant="secondary" className="text-sm !py-2 !px-4">Retour</Button>
               <Button onClick={handleNext} disabled={!canProceed} className="w-auto "> Suivant </Button>
          </div>
      </div>
  );
}

// Step 7: User Details
function Step7Details({ setStep, appointments, submitBookingRequest, removeAppointment, selectedDate, selectedTime }) {
  const [formData, setFormData] = useState({ firstName: '', lastName: '', email: '', phone: '', });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [apiError, setApiError] = useState('');

  // Use the helper for calculation
  const { totalDuration, totalPrice, adjustmentApplied } = calculateAdjustedTotals(appointments);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => { const newErrors = {...prev}; delete newErrors[name]; return newErrors; });
    setApiError('');
  };

  const validateForm = () => {
      const newErrors = {};
      if (!formData.firstName) newErrors.firstName = 'Prénom requis';
      if (!formData.lastName) newErrors.lastName = 'Nom requis';
      if (!formData.email) { newErrors.email = 'Email requis'; } else if (!/\S+@\S+\.\S+/.test(formData.email)) { newErrors.email = 'Adresse email invalide'; }
      if (!formData.phone) { newErrors.phone = 'Téléphone requis'; } else if (!/^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/.test(formData.phone)) { newErrors.phone = 'Numéro de téléphone invalide'; }
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
  }
  // handleSubmit should send the original 'appointments' array, backend will recalculate
  const handleSubmit = async (e) => {
      e.preventDefault();
      setApiError('');
      if (!validateForm()) { return; }
      setIsLoading(true);
      // Send the raw appointment data, backend should apply adjustment logic too
      const payload = { formData, appointments, selectedDate, selectedTime };
      try {
        const response = await fetch(`${API_URL}/bookings`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            body: JSON.stringify(payload),
        });          const result = await response.json();
          if (!response.ok) { throw new Error(result.message || `HTTP error! status: ${response.status}`); }
          submitBookingRequest(formData, result.bookingId);
      } catch (error) {
          setApiError(`Erreur lors de la réservation: ${error.message}`);
      } finally {
          setIsLoading(false);
      }
  };
  const handleBackToDateTime = () => { setStep(6); }
  const handleBackToAddService = () => { setStep(5); }

  const hasAtLeastOneService = appointments.some(app => app.coupeServices?.length > 0 || app.techniqueServices?.length > 0 || app.evenementielServices?.length > 0);
  const isBookingPossible = appointments.length > 0 && selectedDate && selectedTime && hasAtLeastOneService;
  const onlyServicesMissing = appointments.length > 0 && !hasAtLeastOneService && selectedDate && selectedTime;
  const formattedDate = selectedDate ? dayjs(selectedDate).format('dddd D MMMM YYYY') : 'Non sélectionnée';
  const endTime = calculateEndTime(selectedTime, totalDuration); // Use adjusted duration for end time display
  const timeRange = selectedTime ? `${selectedTime} - ${endTime || '??:??'}` : 'Non sélectionnée';

  return (
    <div className="z-10 w-full max-w-lg mx-auto ">
      <h2 className="text-3xl font-[cursive] mb-6 p-2 text-center bg-white bg-opacity-40  rounded-xl shadow-lg max-w-md mx-auto">Vos informations</h2>
      <div className="mb-6 p-4 border border-gray-300 rounded-md bg-gray-50 bg-opacity-80">
          <h3 className="text-lg font-semibold mb-2">Récapitulatif :</h3>
           <div className="text-sm mb-2 font-medium"> <p>Date : {formattedDate}</p> <p>Heure : {timeRange}</p> </div>
           <hr className="my-2"/>
          {appointments.length === 0 ? ( <p className="text-sm text-gray-500 italic">Aucune personne/prestation ajoutée.</p> ) : (
            appointments.map((app, index) => (
              <div key={index} className="text-sm mb-3 pb-2 border-b border-gray-200 last:border-b-0">
                  <div className="flex justify-between items-center font-medium text-gray-800">
                      <span>Personne {index + 1}: {app.clientType} - {app.hairLength}</span>
                       <button onClick={() => removeAppointment(index)} title={`Supprimer la personne ${index + 1}`} className="ml-2 px-2 py-0.5 text-xs font-bold text-red-600 border border-red-400 rounded hover:bg-red-100 transition-colors" aria-label={`Supprimer la personne ${index + 1}`}> X </button>
                  </div>
                  {app.coupeServices && app.coupeServices.length > 0 && ( <div className="pl-2"> <p className="text-xs font-medium text-gray-600">Coupe/Coiffage:</p> {app.coupeServices.map(cs => <p key={cs.name} className="pl-2 text-xs"> - {cs.name} ({cs.price}€ / {cs.duration} min)</p>)} </div> )}
                  {app.techniqueServices && app.techniqueServices.length > 0 && ( <div className="pl-2 mt-1"> <p className="text-xs font-medium text-gray-600">Technique:</p> {app.techniqueServices.map(ts => <p key={ts.name} className="pl-2 text-xs"> - {ts.name} ({ts.price}€ / {ts.duration} min)</p>)} </div> )}
                  {app.evenementielServices && app.evenementielServices.length > 0 && ( <div className="pl-2 mt-1"> <p className="text-xs font-medium text-gray-600">Évènementiel:</p> {app.evenementielServices.map(es => <p key={es.name} className="pl-2 text-xs"> - {es.name} ({es.price}€ / {es.duration} min)</p>)} </div> )}
                  {(!app.coupeServices || app.coupeServices.length === 0) && (!app.techniqueServices || app.techniqueServices.length === 0) && (!app.evenementielServices || app.evenementielServices.length === 0) && ( <p className="pl-2 italic text-gray-500 text-xs">Aucune prestation sélectionnée pour cette personne.</p> )}
              </div>
            ))
          )}
          {/* Display adjusted totals */}
          {appointments.length > 0 && hasAtLeastOneService && (
            <>
              <hr className="my-2"/>
              <div className="text-md font-semibold flex justify-between">
                <span>Total Général :</span>
                <span>{totalPrice}€ ({totalDuration} min)</span>
              </div>
              {adjustmentApplied && <p className="text-xs text-blue-600 text-right">(Ajustement appliqué)</p>}
            </>
          )}
      </div>
      {/* ... Form and buttons ... */}
       {apiError && <p className="text-red-600 text-center mb-4">{apiError}</p>}
      {isBookingPossible ? (
        <form onSubmit={handleSubmit} className="space-y-4">
            {/* Form inputs */}
           <div> <label htmlFor="firstName" className="block text-sm font-medium text-gray-300">Prénom (Contact Principal)</label> <input type="text" id="firstName" name="firstName" value={formData.firstName} onChange={handleChange} required disabled={isLoading} className={`mt-1 block w-full px-3 py-2 border ${errors.firstName ? 'border-red-500' : 'border-gray-300'} rounded-md shadow-sm focus:outline-none focus:ring-black focus:border-black sm:text-sm`} /> {errors.firstName && <p className="text-red-500 text-xs mt-1">{errors.firstName}</p>} </div>
           <div> <label htmlFor="lastName" className="block text-sm font-medium text-gray-300">Nom (Contact Principal)</label> <input type="text" id="lastName" name="lastName" value={formData.lastName} onChange={handleChange} required disabled={isLoading} className={`mt-1 block w-full px-3 py-2 border ${errors.lastName ? 'border-red-500' : 'border-gray-300'} rounded-md shadow-sm focus:outline-none focus:ring-black focus:border-black sm:text-sm`} /> {errors.lastName && <p className="text-red-500 text-xs mt-1">{errors.lastName}</p>} </div>
           <div> <label htmlFor="email" className="block text-sm font-medium text-gray-300">Email (Contact Principal)</label> <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required disabled={isLoading} className={`mt-1 block w-full px-3 py-2 border ${errors.email ? 'border-red-500' : 'border-gray-300'} rounded-md shadow-sm focus:outline-none focus:ring-black focus:border-black sm:text-sm`} /> {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>} </div>
           <div> <label htmlFor="phone" className="block text-sm font-medium text-gray-300">Téléphone (Contact Principal)</label> <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required disabled={isLoading} placeholder="Ex: 0612345678" className={`mt-1 block w-full px-3 py-2 border ${errors.phone ? 'border-red-500' : 'border-gray-300'} rounded-md shadow-sm focus:outline-none focus:ring-black focus:border-black sm:text-sm`} /> {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone}</p>} </div>
          <div className="flex justify-between items-center pt-4">
               <Button onClick={handleBackToDateTime} variant="secondary" className="text-sm !py-2 !px-4" disabled={isLoading}>Retour</Button>
               <Button type="submit" className="w-auto" disabled={isLoading}> {isLoading ? 'Envoi en cours...' : 'Soumettre la demande'} </Button>
          </div>
        </form>
      ) : (
        // Fallback buttons if booking not possible
         <div className="text-center mt-6">
             {onlyServicesMissing ? (
                 <>
                    <p className="text-red-500 mb-4">Veuillez sélectionner au moins une prestation pour au moins une personne.</p>
                    <div className="flex justify-center items-center space-x-4">
                         <Button onClick={handleBackToDateTime} variant="secondary" className="text-sm !py-2 !px-4">Modifier Date/Heure</Button>
                         <Button onClick={handleBackToAddService} variant="primary" className="text-sm !py-2 !px-4">Ajouter/Modifier Prestations</Button>
                    </div>
                 </>
             ) : (
                 <>
                    <p className="text-red-500 mb-4">Veuillez ajouter des personnes/prestations et sélectionner une date/heure.</p>
                    <Button onClick={() => setStep(appointments.length === 0 ? 5 : 6)} variant="secondary">Retour</Button>
                 </>
             )}
         </div>
      )}
    </div>
  );
}

// Step 8: Enter Confirmation Code
function Step8EnterCode({ setStep, bookingDetails }) {
    const [enteredCode, setEnteredCode] = useState('');
    const [errorCode, setErrorCode] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const email = bookingDetails?.formData?.email || 'votre adresse email';
    const bookingId = bookingDetails?.bookingId;

    const handleCodeChange = (e) => { setEnteredCode(e.target.value); setErrorCode(''); };

    // MODIFIED: Use API call logic (uncommented)
    const handleConfirmCode = async () => {
        if (!bookingId) {
             setErrorCode("Erreur: ID de réservation manquant.");
             return;
        }
        setErrorCode('');
        setIsLoading(true);
        console.log(`Comparing entered code (trimmed): "${enteredCode.trim()}"`); // DEBUG

        /* // --- SIMULATION LOGIC (Commented out) ---
        const simulatedCorrectCode = "123456";
        if (enteredCode.trim() === simulatedCorrectCode) {
            console.log("Code verification simulation successful");
            setTimeout(() => {
                setIsLoading(false);
                setStep(9);
            }, 500);
        } else {
            console.log("Code verification simulation failed");
             setTimeout(() => {
                setIsLoading(false);
                setErrorCode('Code de confirmation invalide ou incorrect.');
            }, 500);
        }
        */

        // --- REAL API CALL (Activated) ---
        try {
            console.log(`Sending code confirmation for bookingId: ${bookingId}, code: ${enteredCode}`);
            const response = await fetch(`${API_URL}/bookings/confirm`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', },
                body: JSON.stringify({ bookingId: bookingId, enteredCode: enteredCode.trim() }), // Use trim() here too
            });
            const result = await response.json(); // Try to parse JSON always
            if (!response.ok) {
                 console.error("API Error Response:", result);
                 // Use message from backend if available, otherwise generic error
                 throw new Error(result.message || `Erreur serveur (${response.status})`);
            }
            console.log("API Success Response:", result);
            setStep(9); // Proceed on success
        } catch (error) {
             console.error('Failed to confirm code:', error);
             // Display specific error from backend or a fallback
             setErrorCode(error.message || "Erreur lors de la confirmation du code.");
        } finally {
            setIsLoading(false); // Ensure loading is reset
        }
        // --- END REAL API CALL ---
    };

    if (!bookingDetails) {
        return <p className="text-center text-red-500">Erreur: Impossible de charger les détails de la réservation.</p>;
    }
    return (
        <div className="z-10 w-full max-w-md mx-auto space-y-6 flex flex-col items-center">
            <h2 className="z-10 text-3xl font-[cursive] mb-6 p-2 bg-opacity-50 text-gray-300 backdrop-blur-sm rounded-xl shadow-lg max-w-md mx-auto">Vérifiez votre boîte mail</h2>
            <p className="text-center mb-1 z-10 p-2 bg-opacity-50 text-gray-300 backdrop-blur-sm rounded-xl shadow-lg">Saisissez le code de confirmation envoyé à <strong>{email}</strong>. </p>

            {/* Simulation hint removed as API call is active */}
            <div className="w-full">
                <label htmlFor="confirmation-code" className="backdrop-blur-sm rounded-xl bg-opacity-50 block text-sm font-medium text-gray-300 mb-1">Code de confirmation</label>
                <input type="text" id="confirmation-code" name="confirmation-code" value={enteredCode} onChange={handleCodeChange} required maxLength={6} disabled={isLoading} className={`mt-1 block w-full px-3 py-2 border ${errorCode ? 'border-red-500' : 'border-gray-300'} rounded-md shadow-sm focus:outline-none focus:ring-black focus:border-black sm:text-sm text-center tracking-widest font-mono`} placeholder="______" />
                {/* Error message display */}
                {errorCode && <p className="text-red-500 text-xs mt-1 text-center">{errorCode}</p>}
            </div>
            <div className="flex justify-center items-center pt-4 w-full">
                 <Button onClick={handleConfirmCode} disabled={!enteredCode || isLoading} className="w-auto">
                     {isLoading ? 'Vérification...' : 'Confirmer le code'}
                 </Button>
            </div>
             {/* Removed note about simulation */}
        </div>
    );
}

// Step 9: Final Confirmation Message
function Step9Confirmation({ bookingDetails, startNewBooking }) {
  if (!bookingDetails || !bookingDetails.formData || !bookingDetails.appointments) {
      console.error("Step9Confirmation: bookingDetails prop is missing or incomplete.", bookingDetails);
      return <p className="text-center text-red-500">Erreur: Impossible d'afficher la confirmation.</p>;
  }
  // Use the helper for calculation
  const { totalDuration, totalPrice, adjustmentApplied } = calculateAdjustedTotals(bookingDetails.appointments);

  const formattedDate = bookingDetails.selectedDate ? dayjs(bookingDetails.selectedDate).format('dddd D MMMM YYYY') : 'Non spécifiée';
  const endTime = calculateEndTime(bookingDetails.selectedTime, totalDuration); // Use adjusted duration
  const timeRange = bookingDetails.selectedTime ? `${bookingDetails.selectedTime} - ${endTime || '??:??'}` : 'Non spécifiée';

  return (
      <div className="z-10 text-center max-w-lg mx-auto p-6 bg-gray-50 rounded-lg shadow">
          <h2 className="text-3xl font-[cursive] mb-4 text-green-700">Réservation Confirmée !</h2>
          <p className="mb-4">Merci, {bookingDetails.formData?.firstName || 'Client'} ! Votre rendez-vous est confirmé.</p>
          <p className="mb-6">Nous avons bien enregistré votre demande.</p>
           <div className="mb-6 p-4 border border-gray-300 rounded-md bg-white text-left">
              <h3 className="text-lg font-semibold mb-2">Récapitulatif de votre rendez-vous :</h3>
               <div className="text-sm mb-2 font-medium"> <p>Date : <strong>{formattedDate}</strong></p> <p>Heure : <strong>{timeRange}</strong></p> </div>
               <hr className="my-1"/>
               {Array.isArray(bookingDetails.appointments) && bookingDetails.appointments.map((app, index) => (
                   <div key={index} className="text-sm mb-3 pb-2 border-b border-gray-200 last:border-b-0">
                       <p className="font-medium text-gray-800">Personne {index + 1}: {app?.clientType || 'N/A'} - {app?.hairLength || 'N/A'}</p>
                       {app.coupeServices && app.coupeServices.length > 0 && ( <div className="pl-2"> <p className="text-xs font-medium text-gray-600">Coupe/Coiffage:</p> {app.coupeServices.map(cs => <p key={cs.name} className="pl-2 text-xs"> - {cs.name} ({cs.price}€ / {cs.duration} min)</p>)} </div> )}
                       {app.techniqueServices && app.techniqueServices.length > 0 && ( <div className="pl-2 mt-1"> <p className="text-xs font-medium text-gray-600">Technique:</p> {app.techniqueServices.map(ts => <p key={ts.name} className="pl-2 text-xs"> - {ts.name} ({ts.price}€ / {ts.duration} min)</p>)} </div> )}
                       {app.evenementielServices && app.evenementielServices.length > 0 && ( <div className="pl-2 mt-1"> <p className="text-xs font-medium text-gray-600">Évènementiel:</p> {app.evenementielServices.map(es => <p key={es.name} className="pl-2 text-xs"> - {es.name} ({es.price}€ / {es.duration} min)</p>)} </div> )}
                       {(!app.coupeServices || app.coupeServices.length === 0) && (!app.techniqueServices || app.techniqueServices.length === 0) && (!app.evenementielServices || app.evenementielServices.length === 0) && ( <p className="pl-2 italic text-gray-500 text-xs">Aucune prestation sélectionnée.</p> )}
                   </div>
               ))}
              <hr className="my-2"/>
               {/* Display adjusted totals */}
               <div className="text-md font-semibold flex justify-between">
                   <span>Total Général :</span> <span>{totalPrice}€ ({totalDuration} min)</span>
               </div>
               {adjustmentApplied && <p className="text-xs text-blue-600 text-right">(Ajustement appliqué)</p>}
              <hr className="my-2"/>
               <div className="text-sm mt-2">
                   <p><strong>Nom (Contact):</strong> {bookingDetails.formData?.lastName || ''}, {bookingDetails.formData?.firstName || ''}</p>
                   <p><strong>Téléphone:</strong> {bookingDetails.formData?.phone || ''}</p>
                   <p><strong>Email:</strong> {bookingDetails.formData?.email || ''}</p>
               </div>
          </div>
           <p className="text-xs text-gray-500 mt-4 italic"> Un email de confirmation vous a été envoyé. </p>
           <Button onClick={startNewBooking} variant="primary" className="mt-6"> Nouvelle réservation </Button>
      </div>
  );
}


// Main App Component
function App() {
  const [step, setStep] = useState(1);
  const [showAnimation, setShowAnimation] = useState(true);
  const [appointments, setAppointments] = useState([]);
  const [currentAppointmentIndex, setCurrentAppointmentIndex] = useState(0);
  const [bookingDetails, setBookingDetails] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);


  useEffect(() => { console.log("Current Step:", step); }, [step]);
  useEffect(() => { console.log("Appointments State Updated:", appointments); }, [appointments]);
  useEffect(() => {
    const setVhVariable = () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };
    setVhVariable();
    // Debounce resize/orientation change for performance
    let timeoutId;
    const handleResize = () => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(setVhVariable, 150); // Recalculate after a short delay
    };
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  const addAppointment = (details) => {
    setAppointments(prev => {
        const newAppointments = [...prev];
        newAppointments.push({
            clientType: details.clientType,
            hairLength: null,
            coupeServices: [],
            techniqueServices: [],
            evenementielServices: [] // Add new array
         });
        setCurrentAppointmentIndex(newAppointments.length - 1);
        return newAppointments;
    });
};

    // Updated updateCurrentAppointment to ensure busyDuration is included
    const updateCurrentAppointment = (details) => {
      setAppointments(prev => {
          const newAppointments = [...prev];
          const validIndex = currentAppointmentIndex >= 0 && currentAppointmentIndex < newAppointments.length ? currentAppointmentIndex : -1;
          if (validIndex !== -1) {
              // Ensure all duration fields are copied
              const mapServices = (services) => services?.map(s => ({ ...s })) || [];

              newAppointments[validIndex] = {
                  ...newAppointments[validIndex],
                  coupeServices: details.coupeServices !== undefined ? mapServices(details.coupeServices) : newAppointments[validIndex].coupeServices,
                  techniqueServices: details.techniqueServices !== undefined ? mapServices(details.techniqueServices) : newAppointments[validIndex].techniqueServices,
                  evenementielServices: details.evenementielServices !== undefined ? mapServices(details.evenementielServices) : newAppointments[validIndex].evenementielServices,
                  hairLength: details.hairLength !== undefined ? details.hairLength : newAppointments[validIndex].hairLength,
              };
               console.log("Updated appointment at index", validIndex, newAppointments[validIndex]);
          } else {
              console.error("Attempted to update with invalid index", currentAppointmentIndex);
          }
          return newAppointments;
      });
  };

    const removeAppointment = (indexToRemove) => {
      console.log(`Removing appointment slot at index: ${indexToRemove}`);
      const newAppointments = appointments.filter((_, index) => index !== indexToRemove);
      setAppointments(newAppointments);
       if (newAppointments.length === 0) {
           setCurrentAppointmentIndex(0);
       } else if (indexToRemove < currentAppointmentIndex) {
           setCurrentAppointmentIndex(prev => prev - 1);
       } else {
           setCurrentAppointmentIndex(prev => Math.min(prev, newAppointments.length - 1));
       }
  };

    // handleBookingRequestSuccess now receives bookingId
   const handleBookingRequestSuccess = (formData, bookingIdFromServer) => {
        // Use helper for display totals, but backend needs raw for calculation
        const { totalDuration, totalPrice } = calculateAdjustedTotals(appointments);

        const bookingData = {
            formData: formData,
            appointments: appointments, // Send full data including detailed durations
            selectedDate: selectedDate,
            selectedTime: selectedTime,
            totalDurationCalculated: totalDuration, // Adjusted client duration
            totalPriceCalculated: totalPrice,       // Adjusted price
            bookingId: bookingIdFromServer,
            status: 'pending_code_confirmation',
            createdAt: new Date().toISOString()
        };
        console.log("Storing booking details locally:", bookingData);
        setBookingDetails(bookingData);
        setStep(8);
    };

    // Resets the entire booking process AND hides viewer
    const startNewBooking = () => {
        setStep(1); setAppointments([]); setCurrentAppointmentIndex(0); setBookingDetails(null); setSelectedDate(null); setSelectedTime(null);
    }

   const validCurrentIndex = currentAppointmentIndex >= 0 && currentAppointmentIndex < appointments.length ? currentAppointmentIndex : 0;
   const currentAppointmentData = appointments[validCurrentIndex] || { clientType: null, hairLength: null, coupeServices: [], techniqueServices: [], evenementielServices: [] };

  // Render correct step component based on current step number
  // OR render viewer if showViewer is true
  const renderContent = () => {
    console.log(`Rendering Step Component for step: ${step}`);
    switch (step) {
      case 1: return <Step1Action setStep={setStep} setShowAnimation={setShowAnimation} />;
      case 2: return <Step2ClientType setStep={setStep} addAppointment={addAppointment} setShowAnimation={setShowAnimation} />; // <-- Ajoutez setShowAnimation ici
      case 3: return <Step3HairLength setStep={setStep} updateCurrentAppointment={updateCurrentAppointment} currentAppointment={currentAppointmentData} />;
      case 4: return <Step4SelectServices setStep={setStep} updateCurrentAppointment={updateCurrentAppointment} currentAppointment={currentAppointmentData} />;
      case 5: return <Step5AddPerson setStep={setStep} appointments={appointments} />;
      case 6: return <Step6DateTime setStep={setStep} appointments={appointments} selectedDate={selectedDate} setSelectedDate={setSelectedDate} selectedTime={selectedTime} setSelectedTime={setSelectedTime} />;
      case 7: return <Step7Details setStep={setStep} appointments={appointments} submitBookingRequest={handleBookingRequestSuccess} removeAppointment={removeAppointment} selectedDate={selectedDate} selectedTime={selectedTime} />;
      case 8: return <Step8EnterCode setStep={setStep} bookingDetails={bookingDetails} />;
      case 9: return <Step9Confirmation bookingDetails={bookingDetails} startNewBooking={startNewBooking} />;
      default: return <Step1Action setStep={setStep} />; // Default or handle step 0 if needed
    }
  };

  const numberOfStrands = 7;

  return (
    <div
        className="relative w-full min-h-screen font-sans bg-center bg-cover bg-fixed"
        style={{ backgroundImage: `url(${imageSalon})` }}
    >
    <div className="absolute inset-0 bg-black bg-opacity-60 z-0"></div>
            {/* Container for the hair animation */}
      {showAnimation && (
      <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none">
        {/* Generate multiple divs to act as hair strands */}
        {Array.from({ length: numberOfStrands }).map((_, index) => (
          <div
            key={index}
            className="hair-strand"
            // Inline style for unique positioning and animation delay/duration
            style={{
              // Distribute horizontally with more randomness
              left: `${(index / numberOfStrands) * 100 + Math.random() * 4 - 2}%`,
              // Random start delay
              animationDelay: `${Math.random() * 2.5}s`,
              // Random duration for more variation
              animationDuration: `${5 + Math.random() * 5}s`,
            }}
          ></div>
        ))}
      </div>
      )}
        <style> {`
            @import url('https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap');
            .font-\\[cursive\\] { font-family: 'Great Vibes', cursive; }
            /* Ensure html/body allow content to take full height */
            html, body, #root { height: 100%; width: 100%; margin: 0; padding: 0; overflow-x: hidden; }
            body { background-color: #ffffff; color: #000000; font-family: 'Inter', sans-serif; }
            /* ... input/label styles ... */
            /* ... animation styles ... */
         `} </style>
      <div className="relative z-10 w-full flex flex-col overflow-y-auto" style={{ height: 'calc(var(--vh, 1vh) * 100)' }}>
      <Header />
      <main className="flex-grow container mx-auto px-4 pt-6 pb-8 md:pt-8 md:pb-12 flex justify-center">
        <div className="w-full max-w-4xl"> {/* Example max-width */}
          {renderContent()}
        </div>
      </main>
       <Footer />

    </div>
    </div>
  );
}

export default App;